import { Button, Col, Form, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { RegisterationText } from "texts/registerationText";
import FormItem from "../_atoms/FormIItem";
import { ArrowLeftIconOutline } from "../icons";
import { useEffect, useState } from "react";
import { useAppSelector } from "redux/reduxHook";
import { useGetParsiMapLocation } from "api/map/mapApis.rq";
import { generalTexts } from "texts/generalTexts";

interface Props {
  nextStepHandler: (value) => void;
  handleChangeStep: (step: number, data: any) => void;
}
const RegisterStep5 = ({ nextStepHandler, handleChangeStep }: Props) => {
  const [form] = Form.useForm();
  const mapInfo = useAppSelector((state) => state.mapInfo);
  const { data: ParsiMapAddressData, isLoading } = useGetParsiMapLocation(`${[mapInfo?.viewportNew?.longitude, mapInfo?.viewportNew?.latitude]}`);
  const [formData, setFormData] = useState({
    address: null,
    city: null,
    province: null,
    plaque: null,
    region: null,
  });
  useEffect(() => {
    setFormData({
      address: ParsiMapAddressData?.address,
      city: ParsiMapAddressData?.subdivision_prefix,
      province: ParsiMapAddressData?.subdivision_prefix,
      plaque: null,
      region: null,
    });
  }, [ParsiMapAddressData]);

  const onFinish = () => {
    const address = formData?.address + " پلاک " + formData?.plaque + " طبقه " + formData?.region;
    const body = {
      province: formData?.province,
      city: formData?.city,
      region: formData?.region,
      latitude: mapInfo?.viewportNew?.latitude,
      longitude: mapInfo?.viewportNew?.longitude,
      address: address,
    };
    nextStepHandler(body);
  };

  return (
    <div className="w-full -mt-12">
      <p className="text-right text-sm font-medium pb-8">{RegisterationText?.addAddressDetail}</p>
      {isLoading === false ? (
        <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
          <FormItem label={RegisterationText?.postalAddress} name="address" rules={[{ required: false }]}>
            <TextArea size="large" defaultValue={ParsiMapAddressData?.address} className=" w-full" onChange={(e) => setFormData({ ...formData, address: e?.target?.value })} />
          </FormItem>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label={RegisterationText?.province} name="province" rules={[{ required: false }]}>
                <Input defaultValue={ParsiMapAddressData?.subdivision_prefix} className="hover:border-r-0 w-full" size="large" onChange={(e) => setFormData({ ...formData, province: "تهران" })} disabled />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label={RegisterationText?.city} name="city" rules={[{ required: false }]}>
                <Input defaultValue={ParsiMapAddressData?.subdivision_prefix} className="hover:border-r-0 w-full" size="large" onChange={(e) => setFormData({ ...formData, city: "تهران" })} disabled />
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <FormItem label={RegisterationText?.region} name="region" rules={[{ required: true }]}>
                <Input value={formData?.region} className="hover:border-r-0 w-full" size="large" onChange={(e) => setFormData({ ...formData, region: e?.target?.value })} />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label={RegisterationText?.plaque} name="plaque" rules={[{ required: true }]}>
                <Input value={formData?.plaque} className="hover:border-r-0 w-full" size="large" onChange={(e) => setFormData({ ...formData, plaque: e?.target?.value })} />
              </FormItem>
            </Col>
          </Row>
          <div className="flex mt-6 gap-x-4">
            <Button
              type="text"
              className="bg-white flex justify-center !px-0 items-center gap-x-1 border border-black text-black w-full"
              onClick={(e) => handleChangeStep(4, { latitude: mapInfo?.viewportNew?.latitude, longitude: mapInfo?.viewportNew?.longitude })}
              size="large"
            >
              {generalTexts?.returnToBeforePage}
              <ArrowLeftIconOutline width={24} height={24} stroke="black" />
            </Button>
            <Button type="text" className="bg-black !px-0 flex justify-center items-center gap-x-1 border border-black text-white w-full" htmlType="submit" size="large">
              {RegisterationText?.saveDetailsAndContinue}
              <ArrowLeftIconOutline width={24} height={24} stroke="white" />
            </Button>
          </div>
        </Form>
      ) : null}
    </div>
  );
};
export default RegisterStep5;
